import { render, staticRenderFns } from "./peoLing.vue?vue&type=template&id=18b6ca6f&scoped=true&"
import script from "./peoLing.vue?vue&type=script&lang=js&"
export * from "./peoLing.vue?vue&type=script&lang=js&"
import style0 from "./peoLing.vue?vue&type=style&index=0&id=18b6ca6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b6ca6f",
  null
  
)

export default component.exports